<template>
    <div>
        <div class="sidebar open" v-if="$route.name !== 'login'">
            <div class="collapse-container" @click="onCollapseSidebarClicked()">
                <div class="h-100 d-flex align-items-center justify-content-center clickable">
                    <i class="fa fa-chevron-right text-white" :class="{'rotate180': sidebarCollapsed}"></i>
                </div>
            </div>
            <div class="sidebar-header">
                <div style="height:150px">
                    <h3 class="text-center text-white mt-4 username"
                        :class="{'opacity0': sidebarCollapsed && sidebarAnimationCompleted}">{{userName}}</h3>
                </div>
                <div class="avatar" :class="{'opacity0': sidebarCollapsed && sidebarAnimationCompleted}">
                    <img :src="avatar" class="img-fluid">
                </div>
            </div>

            <div class="menu-container">
                <ul class="nav flex-column accordion" id="accordion">
                    <li class="nav-item">
                        <router-link to="/home" class="nav-link" id="home">
                            <span>
                                <i class="ic-home ml-3"></i>
                                <span v-if="!sidebarCollapsed && sidebarAnimationCompleted">پیشخوان</span>
                                <b-tooltip target="home" placement="left" offset="-2" boundary-padding="30"
                                           triggers="hover" v-if="sidebarCollapsed">
                                    پیشخوان
                                </b-tooltip>
                            </span>
                        </router-link>
                    </li>
                    <li class="nav-item">
                        <router-link to="/messages" class="nav-link" id="messages">
                            <span>
                                <i class="fa fa-comment-o ml-3"></i>
                                <span v-if="!sidebarCollapsed && sidebarAnimationCompleted">پیامها</span>
                                <b-tooltip target="messages" placement="left" offset="-2" boundary-padding="30"
                                           triggers="hover" v-if="sidebarCollapsed">
                                    پیامها
                                </b-tooltip>
                            </span>
                        </router-link>
                    </li>
                    <!--<li class="nav-item">-->
                        <!--<a class="nav-link collapsible collapsed" data-toggle="collapse"-->
                           <!--data-target="#competitionsSubMenu"-->
                           <!--role="button" id="competitionsMenu">-->
                    <!--&lt;!&ndash;<span>&ndash;&gt;-->
                    <!--&lt;!&ndash;<i class="ic-report  ml-3"></i>&ndash;&gt;-->
                    <!--&lt;!&ndash;<span v-if="!sidebarCollapsed && sidebarAnimationCompleted">مشاهده صورتحسابها</span>&ndash;&gt;-->
                    <!--&lt;!&ndash;<b-tooltip target="competitionsMenu" placement="left" offset="-2" boundary-padding="30"&ndash;&gt;-->
                               <!--&lt;!&ndash;triggers="hover" v-if="sidebarCollapsed">&ndash;&gt;-->
                    <!--&lt;!&ndash;مشاهده صورتحسابها&ndash;&gt;-->
                    <!--&lt;!&ndash;</b-tooltip>&ndash;&gt;-->
                    <!--&lt;!&ndash;</span>&ndash;&gt;-->
                            <!--<i class="fa fa-chevron-down" v-if="!sidebarCollapsed && sidebarAnimationCompleted"></i>-->
                        <!--</a>-->
                    <!--</li>-->
                    <!--<div class="collapse" id="competitionsSubMenu" data-parent="#accordion">-->
                        <!--<li class="nav-item">-->
                            <!--<router-link to="/depositreport" class="nav-link" id="competitionRegistration">-->
                    <!--<span>-->
                    <!--<i class="fa fa-bar-chart ml-3"></i>-->
                    <!--<span v-if="!sidebarCollapsed && sidebarAnimationCompleted">حساب سپرده</span>-->
                    <!--<b-tooltip target="competitionRegistration" placement="left" offset="-2"-->
                               <!--boundary-padding="30" triggers="hover" v-if="sidebarCollapsed">-->
                    <!--حساب سپرده-->
                    <!--</b-tooltip>-->
                    <!--</span>-->
                            <!--</router-link>-->
                        <!--</li>-->

                        <!--<li class="nav-item" id="createMatch">-->
                            <!--<router-link to="/loanreport" class="nav-link" id="loanreport">-->
                    <!--<span>-->
                    <!--<i class="fa fa-signal ml-3"></i>-->
                    <!--<span v-if="!sidebarCollapsed && sidebarAnimationCompleted">حساب وام</span>-->
                    <!--<b-tooltip target="loanreport" placement="left" offset="-2" boundary-padding="30"-->
                               <!--triggers="hover" v-if="sidebarCollapsed">-->
                    <!--حساب وام-->
                    <!--</b-tooltip>-->
                    <!--</span>-->
                            <!--</router-link>-->
                        <!--</li>-->
                    <!--</div>-->
                    <li class="nav-item">
                        <a class="nav-link collapsible collapsed" data-toggle="collapse"
                           data-target="#competitionsSubMenu2"
                           role="button" id="competitionsMenu2">
                            <span>
                                <i class="ic-definition-requirements  ml-3"></i>
                                <span v-if="!sidebarCollapsed && sidebarAnimationCompleted">پرداختهای آنلاین</span>
                                <b-tooltip target="competitionsMenu2" placement="left" offset="-2" boundary-padding="30"
                                           triggers="hover" v-if="sidebarCollapsed">
                                    پرداختهای آنلاین
                                </b-tooltip>
                            </span>
                            <i class="fa fa-chevron-down" v-if="!sidebarCollapsed && sidebarAnimationCompleted"></i>
                        </a>
                    </li>
                    <div class="collapse" id="competitionsSubMenu2" data-parent="#accordion">
                        <li class="nav-item">
                            <router-link to="/paymentreport" class="nav-link" id="paymentreport">
                                <span>
                                    <i class="ic-check  ml-3"></i>
                                    <span v-if="!sidebarCollapsed && sidebarAnimationCompleted">سابقه فیش های ثبتی</span>
                                    <b-tooltip target="paymentreport" placement="left" offset="-2" boundary-padding="30"
                                               triggers="hover" v-if="sidebarCollapsed">
                                        سابقه فیش های ثبتی
                                    </b-tooltip>
                                </span>
                            </router-link>
                        </li>

                        <li class="nav-item" id="createMatch2">
                            <router-link to="/newpayment" class="nav-link" id="newpayment">
                            <span>
                                <i class="fa fa-plus-circle ml-3"></i>
                                <span v-if="!sidebarCollapsed && sidebarAnimationCompleted">ثبت فیش پرداخت</span>
                                <b-tooltip target="newpayment" placement="left" offset="-2" boundary-padding="30"
                                           triggers="hover" v-if="sidebarCollapsed">
                                    ثبت فیش پرداخت
                                </b-tooltip>
                            </span>
                            </router-link>
                        </li>
                    </div>
                    <li class="nav-item">
                        <a class="nav-link collapsible collapsed" data-toggle="collapse" data-target="#clubsSubMenu"
                           role="button" id="clubsMenu">
                            <span>
                                <i class="ic-lottery  ml-3"></i>
                                <span v-if="!sidebarCollapsed && sidebarAnimationCompleted">درخواستها</span>
                                <b-tooltip target="clubsMenu" placement="left" offset="-2" boundary-padding="30"
                                           triggers="hover" v-if="sidebarCollapsed">
                                    درخواستها
                                </b-tooltip>
                            </span>
                            <i class="fa fa-chevron-down" v-if="!sidebarCollapsed && sidebarAnimationCompleted"></i>
                        </a>
                    </li>
                    <div class="collapse" id="clubsSubMenu" data-parent="#accordion">
                        <li class="nav-item">
                            <router-link to="/requestreport" class="nav-link" id="clubManagement">
                            <span>
                                 <i class="ic-hourglass ml-3"></i>
                                <span v-if="!sidebarCollapsed && sidebarAnimationCompleted">سوابق درخواستها</span>
                                <b-tooltip target="clubManagement" placement="left" offset="-2" boundary-padding="30"
                                           triggers="hover" v-if="sidebarCollapsed">
                                    سوابق درخواستها
                                </b-tooltip>
                            </span>
                            </router-link>
                        </li>
                        <li class="nav-item">
                            <router-link to="/newrequest" class="nav-link" id="clubRegistration">
                                <span>
                                    <i class="ic-definitions ml-3"></i>
                                    <span v-if="!sidebarCollapsed && sidebarAnimationCompleted">درخواست وام</span>
                                    <b-tooltip target="clubRegistration" placement="left" offset="-2"
                                               boundary-padding="30" triggers="hover" v-if="sidebarCollapsed">
                                        درخواست وام
                                    </b-tooltip>
                                </span>
                            </router-link>
                        </li>

                    </div>


                    <!--------------------------------------------T A X S E R V I C E-->
                    <li class="nav-item" v-if="taxManager">
                        <a class="nav-link collapsible collapsed" data-toggle="collapse" data-target="#taxSubMenu"
                           role="button" id="taxMenu">
                            <span>
                                <i class="ic-definition-roles  ml-3"></i>
                                <span v-if="!sidebarCollapsed && sidebarAnimationCompleted">مالیات</span>
                                <b-tooltip target="taxMenu" placement="left" offset="-2" boundary-padding="30"
                                           triggers="hover" v-if="sidebarCollapsed">
                                    مالیات
                                </b-tooltip>
                            </span>
                            <i class="fa fa-chevron-down" v-if="!sidebarCollapsed && sidebarAnimationCompleted"></i>
                        </a>
                    </li>
                    <div class="collapse" id="taxSubMenu" data-parent="#accordion">

                        <li class="nav-item">
                            <router-link to="/sellFactors" class="nav-link" id="taxsellFactors">
                                <span>
                                    <i class="ic-clock-future ml-3"></i>
                                    <span v-if="!sidebarCollapsed && sidebarAnimationCompleted">ارسال نشده</span>
                                    <b-tooltip target="taxsellFactors" placement="left" offset="-2"
                                               boundary-padding="30" triggers="hover" v-if="sidebarCollapsed">
                                        ارسال نشده
                                    </b-tooltip>
                                </span>
                            </router-link>
                        </li>
                        <li class="nav-item">
                            <router-link to="/sentFactors" class="nav-link" id="taxsentFactors">
                                <span>
                                    <i class="ic-check ml-3"></i>
                                    <span v-if="!sidebarCollapsed && sidebarAnimationCompleted">ارسال شده</span>
                                    <b-tooltip target="taxsentFactors" placement="left" offset="-2"
                                               boundary-padding="30" triggers="hover" v-if="sidebarCollapsed">
                                        ارسال شده
                                    </b-tooltip>
                                </span>
                            </router-link>
                        </li>
                        <li class="nav-item">
                            <router-link to="/successFactors" class="nav-link" id="taxsuccessFactors">
                                <span>
                                    <i class="ic-certificate ml-3"></i>
                                    <span v-if="!sidebarCollapsed && sidebarAnimationCompleted">تایید شده</span>
                                    <b-tooltip target="taxsuccessFactors" placement="left" offset="-2"
                                               boundary-padding="30" triggers="hover" v-if="sidebarCollapsed">
                                        تایید شده
                                    </b-tooltip>
                                </span>
                            </router-link>
                        </li>

                    </div>
                    <!--------------------------------------------T A X S E R V I C E-->

                    <li class="nav-item">
                        <a class="nav-link collapsible collapsed" data-toggle="collapse" data-target="#profileSubMenu"
                           role="button" id="profileMenu">
                            <span>
                                <i class="ic-user   ml-3"></i>
                                <span v-if="!sidebarCollapsed && sidebarAnimationCompleted">پروفایل</span>
                                <b-tooltip target="profileMenu" placement="left" offset="-2" boundary-padding="30"
                                           triggers="hover" v-if="sidebarCollapsed">
                                    پروفایل
                                </b-tooltip>
                            </span>
                            <i class="fa fa-chevron-down" v-if="!sidebarCollapsed && sidebarAnimationCompleted"></i>
                        </a>
                    </li>
                    <div class="collapse" id="profileSubMenu" data-parent="#accordion">
                        <li class="nav-item">
                            <router-link to="/profile" class="nav-link" id="profile">
                                <span>
                                    <i class="ic-profile  ml-3"></i>
                                    <span v-if="!sidebarCollapsed && sidebarAnimationCompleted">ویرایش اطلاعات</span>
                                    <b-tooltip target="profile" placement="left" offset="-2" boundary-padding="30"
                                               triggers="hover" v-if="sidebarCollapsed">
                                        ویرایش اطلاعات
                                    </b-tooltip>
                                </span>
                            </router-link>
                        </li>
                        <li class="nav-item" v-if="taxManager">
                            <router-link to="/register" class="nav-link" id="taxregister">
                            <span>
                                 <i class="ic-coach ml-3"></i>
                                <span v-if="!sidebarCollapsed && sidebarAnimationCompleted">پروفایل مالیاتی</span>
                                <b-tooltip target="taxregister" placement="left" offset="-2" boundary-padding="30"
                                           triggers="hover" v-if="sidebarCollapsed">
                                    پروفایل مالیاتی
                                </b-tooltip>
                            </span>
                            </router-link>
                        </li>

                    </div>

                    <li class="nav-item">
                        <router-link to="/settings" class="nav-link" id="settings">
                            <span>
                                <i class="ic-settings  ml-3"></i>
                                <span v-if="!sidebarCollapsed && sidebarAnimationCompleted">تنظیمات</span>
                                <b-tooltip target="settings" placement="left" offset="-2" boundary-padding="30"
                                           triggers="hover" v-if="sidebarCollapsed">
                                    تنظیمات
                                </b-tooltip>
                            </span>
                        </router-link>
                    </li>
                    <li class="nav-item" v-if="role === 'admin'">
                        <a class="nav-link collapsible collapsed" data-toggle="collapse" data-target="#definitions"
                           role="button" id="definitionsDropDown">
                            <span>
                                <i class="ic-definitions ic-1-25x ml-3"></i>
                                <span v-if="!sidebarCollapsed && sidebarAnimationCompleted">تعاریف اولیه</span>
                                <b-tooltip target="definitionsDropDown" placement="left" offset="-2"
                                           boundary-padding="30" triggers="hover" v-if="sidebarCollapsed">
                                    تعاریف اولیه
                                </b-tooltip>
                            </span>
                            <i class="fa fa-chevron-down" v-if="!sidebarCollapsed && sidebarAnimationCompleted"></i>
                        </a>
                    </li>
                    <div class="collapse" id="definitions" data-parent="#accordion">
                        <li class="nav-item">
                            <router-link to="/admin/fields" class="nav-link" id="fields">
                                <span>
                                    <i class="ic-fields ic-1-25x ml-3"></i>
                                    <span v-if="!sidebarCollapsed && sidebarAnimationCompleted">رشته ها</span>
                                    <b-tooltip target="fields" placement="left" offset="-2" boundary-padding="30"
                                               triggers="hover" v-if="sidebarCollapsed">
                                        رشته ها
                                    </b-tooltip>
                                </span>
                            </router-link>
                        </li>
                        <li class="nav-item">
                            <router-link to="/admin/styles" class="nav-link" id="styles">
                                <span>
                                    <i class="ic-definition-styles ic-1-25x ml-3"></i>
                                    <span v-if="!sidebarCollapsed && sidebarAnimationCompleted">سبک ها</span>
                                    <b-tooltip target="styles" placement="left" offset="-2" boundary-padding="30"
                                               triggers="hover" v-if="sidebarCollapsed">
                                        سبک ها
                                    </b-tooltip>
                                </span>
                            </router-link>
                        </li>
                        <li class="nav-item">
                            <router-link to="/admin/requirements" class="nav-link" id="requirements">
                                <span>
                                    <i class="ic-definition-requirements ic-1-25x ml-3"></i>
                                    <span v-if="!sidebarCollapsed && sidebarAnimationCompleted">الزامات</span>
                                    <b-tooltip target="requirements" placement="left" offset="-2" boundary-padding="30"
                                               triggers="hover" v-if="sidebarCollapsed">
                                        الزامات
                                    </b-tooltip>
                                </span>
                            </router-link>
                        </li>
                        <li class="nav-item">
                            <router-link to="/admin/styleRequirements" class="nav-link" id="styleRequirements">
                                <span>
                                    <i class="ic-definition-style-requirements ic-1-25x ml-3"></i>
                                    <span v-if="!sidebarCollapsed && sidebarAnimationCompleted">الزامات سبک ها</span>
                                    <b-tooltip target="styleRequirements" placement="left" offset="-2"
                                               boundary-padding="30" triggers="hover" v-if="sidebarCollapsed">
                                        الزامات سبک ها
                                    </b-tooltip>
                                </span>
                            </router-link>
                        </li>
                        <li class="nav-item">
                            <router-link to="/admin/styleRoles" class="nav-link" id="styleRoles">
                                <span>
                                    <i class="ic-definition-roles ic-1-25x ml-3"></i>
                                    <span v-if="!sidebarCollapsed && sidebarAnimationCompleted">نقش ها</span>
                                    <b-tooltip target="styleRoles" placement="left" offset="-2" boundary-padding="30"
                                               triggers="hover" v-if="sidebarCollapsed">
                                        نقش ها
                                    </b-tooltip>
                                </span>
                            </router-link>
                        </li>
                        <!--<li class="nav-item">
                            <router-link to="/admin/ageRanges" class="nav-link">
                                <span>رده های سنی</span>
                            </router-link>
                        </li>
                        <li class="nav-item">
                            <router-link to="/admin/weightRanges" class="nav-link">
                                <span>رده های وزنی</span>
                            </router-link>
                        </li>-->
                    </div>
                    <li class="nav-item" v-if="role === 'admin'">
                        <a class="nav-link collapsible collapsed" data-toggle="collapse" data-target="#verifications"
                           role="button" id="verificationsDropDown">
                            <span>
                                <i class="ic-certificate ic-1-25x ml-3"></i>
                                <span v-if="!sidebarCollapsed && sidebarAnimationCompleted">تایید مدارک</span>
                                <b-tooltip target="verificationsDropDown" placement="left" offset="-2"
                                           boundary-padding="30" triggers="hover" v-if="sidebarCollapsed">
                                    تایید مدارک
                                </b-tooltip>
                            </span>
                            <i class="fa fa-chevron-down" v-if="!sidebarCollapsed && sidebarAnimationCompleted"></i>
                        </a>
                    </li>
                    <div class="collapse" id="verifications" data-parent="#accordion">
                        <li class="nav-item">
                            <router-link to="/admin/verifications/coaches" class="nav-link" id="coaches">
                                <span>
                                    <i class="ic-coach ic-1-25x ml-3"></i>
                                    <span v-if="!sidebarCollapsed && sidebarAnimationCompleted">مربی ها</span>
                                    <b-tooltip target="coaches" placement="left" offset="-2" boundary-padding="30"
                                               triggers="hover" v-if="sidebarCollapsed">
                                        مربی ها
                                    </b-tooltip>
                                </span>
                            </router-link>
                        </li>
                        <li class="nav-item">
                            <router-link to="/admin/verifications/referees" class="nav-link" id="referees">
                                <span>
                                    <i class="ic-referee-whistle ic-1-25x ml-3"></i>
                                    <span v-if="!sidebarCollapsed && sidebarAnimationCompleted">داور ها</span>
                                    <b-tooltip target="referees" placement="left" offset="-2" boundary-padding="30"
                                               triggers="hover" v-if="sidebarCollapsed">
                                        داور ها
                                    </b-tooltip>
                                </span>
                            </router-link>
                        </li>
                        <li class="nav-item">
                            <router-link to="/admin/verifications/clubs" class="nav-link" id="clubs">
                                <span>
                                    <i class="ic-gym ic-1-25x ml-3"></i>
                                    <span v-if="!sidebarCollapsed && sidebarAnimationCompleted">باشگاه ها</span>
                                    <b-tooltip target="clubs" placement="left" offset="-2" boundary-padding="30"
                                               triggers="hover" v-if="sidebarCollapsed">
                                        باشگاه ها
                                    </b-tooltip>
                                </span>
                            </router-link>
                        </li>
                        <li class="nav-item">
                            <router-link to="/admin/verifications/competitionLicenses" class="nav-link"
                                         id="competitionLicenses">
                                <span>
                                    <i class="ic-certificate ic-1-25x ml-3"></i>
                                    <span v-if="!sidebarCollapsed && sidebarAnimationCompleted">مجوز مسابقات</span>
                                    <b-tooltip target="competitionLicenses" placement="left" offset="-2"
                                               boundary-padding="30" triggers="hover" v-if="sidebarCollapsed">
                                        مجوز مسابقات
                                    </b-tooltip>
                                </span>
                            </router-link>
                        </li>
                    </div>
                    <li class="nav-item" v-if="role === 'admin'">
                        <a class="nav-link collapsible collapsed" data-toggle="collapse" data-target="#reports"
                           role="button" id="reportsDropDown">
                            <span>
                                <i class="ic-report ic-1-25x ml-3"></i>
                                <span v-if="!sidebarCollapsed && sidebarAnimationCompleted">گزارشات</span>
                                <b-tooltip target="reportsDropDown" placement="left" offset="-2" boundary-padding="30"
                                           triggers="hover" v-if="sidebarCollapsed">
                                    گزارشات
                                </b-tooltip>
                            </span>
                            <i class="fa fa-chevron-down" v-if="!sidebarCollapsed && sidebarAnimationCompleted"></i>
                        </a>
                    </li>
                    <div class="collapse" id="reports" data-parent="#accordion">
                        <li class="nav-item">
                            <router-link to="/admin/reports/users" class="nav-link" id="usersList">
                                <span>
                                    <i class="ic-user ic-1-25x ml-3"></i>
                                    <span v-if="!sidebarCollapsed && sidebarAnimationCompleted">لیست کاربران</span>
                                    <b-tooltip target="usersList" placement="left" offset="-2" boundary-padding="30"
                                               triggers="hover" v-if="sidebarCollapsed">
                                        لیست کاربران
                                    </b-tooltip>
                                </span>
                            </router-link>
                        </li>
                        <li class="nav-item">
                            <router-link to="/admin/reports/coaches" class="nav-link" id="coachesList">
                                <span>
                                    <i class="ic-coach ic-1-25x ml-3"></i>
                                    <span v-if="!sidebarCollapsed && sidebarAnimationCompleted">لیست مربیان</span>
                                    <b-tooltip target="coachesList" placement="left" offset="-2" boundary-padding="30"
                                               triggers="hover" v-if="sidebarCollapsed">
                                        لیست مربیان
                                    </b-tooltip>
                                </span>
                            </router-link>
                        </li>
                        <li class="nav-item">
                            <router-link to="/admin/reports/referees" class="nav-link" id="refereesList">
                                <span>
                                    <i class="ic-referee ic-1-25x ml-3"></i>
                                    <span v-if="!sidebarCollapsed && sidebarAnimationCompleted">لیست داوران</span>
                                    <b-tooltip target="refereesList" placement="left" offset="-2" boundary-padding="30"
                                               triggers="hover" v-if="sidebarCollapsed">
                                        لیست داوران
                                    </b-tooltip>
                                </span>
                            </router-link>
                        </li>
                        <!--<li class="nav-item">
                            <router-link to="/admin/reports/clubs" class="nav-link" id="clubsList">
                                <span>
                                    <i class="fa fa-home ml-3"></i>
                                    <span v-if="!sidebarCollapsed && sidebarAnimationCompleted">لیست باشگاه ها</span>
                                    <b-tooltip target="clubsList" placement="left" offset="-2" boundary-padding="30" triggers="hover" v-if="sidebarCollapsed">
                                        لیست باشگاه ها
                                    </b-tooltip>
                                </span>
                            </router-link>
                        </li>-->
                        <li class="nav-item">
                            <router-link to="/admin/reports/competitions" class="nav-link" id="competitionsListReport">
                                <span>
                                    <i class="ic-competition ic-1-25x ml-3"></i>
                                    <span v-if="!sidebarCollapsed && sidebarAnimationCompleted">لیست مسابقات</span>
                                    <b-tooltip target="competitionsListReport" placement="left" offset="-2"
                                               boundary-padding="30" triggers="hover" v-if="sidebarCollapsed">
                                        لیست مسابقات
                                    </b-tooltip>
                                </span>
                            </router-link>
                        </li>
                    </div>
                    <!--<li class="nav-item">
                        <a class="nav-link collapsible" data-toggle="collapse" data-target="#website" role="button">
                            <span>منو</span>
                            <i class="fa fa-chevron-down"></i>
                        </a>
                    </li>
                    <div class="collapse" id="website" data-parent="#accordion">
                        <li class="nav-item">
                            <a class="nav-link" href="#">
                                <span>زیر منو 1</span>
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" href="#">
                                <span>زیر منو 2</span>
                            </a>
                        </li>
                    </div>-->
                </ul>
            </div>
        </div>
        <div class="wrapper" :class="{'wide': $route.name === 'login'}">
            <navbar v-if="$route.name !== 'login'"/>
            <transition
                    mode="out-in"
                    name="fade">
                <router-view/>
            </transition>
        </div>

        <!--<modal show="false" ref="insertModal">
            <div class="container">
                <div class="row">
                    <div class="col-12 text-center">
                        <h1>تغییر رمز عبور</h1>
                    </div>
                    <div class="col-lg-6 offset-lg-3 mb-4">
                        <div class="input-group round">
                            <div class="input-group-prepend">
                                <span class="input-group-text">رمزعبور جدید</span>
                            </div>
                            <input class="form-control" v-model="newPassword" @change="passwordValidation">
                        </div>
                    </div>
                    <div class="col-lg-6 offset-lg-3 mb-4">
                        <div class="input-group round">
                            <div class="input-group-prepend">
                                <span class="input-group-text matchPassword" :class="{'error': checkPassword === true , 'match': checkPassword === false , 'uncheck': checkPassword === null}">تکرار رمزعبور</span>
&lt;!&ndash;                                <i class="fa fa-key matchPassword" :class="{'error': checkPassword === true , 'match': checkPassword === false , 'uncheck': checkPassword === null}"></i>&ndash;&gt;
                            </div>
                            <input class="form-control" type="password" v-model="repeatPassword" @input="passwordMatch">
                        </div>
                    </div>

                    <div class="col-12 text-center">
                        <button class="btn btn-success btn-round" @click="onSubmitPassword">ثبت تغییرات</button>
                    </div>
                </div>
            </div>
        </modal>-->
    </div>
</template>

<script>
    import EventBus from '../_framework/event-bus.js';
    import BaseService from "../_framework/api/BaseService";
    import * as $ from "jquery";
    import Utils from "../_framework/utils/Utils";

    let theme = localStorage.getItem("theme");
    if (theme !== null) {
        import(`../assets/styles/themes/${theme}.scss`);
    } else {
        import(`../assets/styles/themes/light.scss`);
    }
    export default {
        data() {
            return {
                name: "",
                admin: false,
                userName: "",
                newPassword: "",
                repeatPassword: "",
                checkPassword: null,
                sidebarCollapsed: false,
                sidebarAnimationCompleted: true,
                avatar: "",
                role: "",
                userId: "",
                taxManager: false,
            }

        },
        beforeMount() {

        },
        mounted() {
            this.userName = localStorage.getItem('userName');
            this.role = localStorage.getItem("role");
            EventBus.$on('userName', value => {
                this.userName = value;
                this.role = localStorage.getItem("role");

            });
            this.userId = localStorage.getItem("userId");

            console.log(this.userId)
            if (this.userId !== undefined && this.userId !== null && this.userId !== "" && (this.userId === "1226" || this.userId === "1227" || this.userId === "302")) {
                this.taxManager = true;
            } else {
                this.taxManager = false;
            }
            EventBus.$on('userId', value => {
                this.userId = value;
                if (this.userId !== undefined && this.userId !== null && this.userId !== "" && (this.userId === "1226" || this.userId === "1227" || this.userId === "302")) {
                    this.taxManager = true;
                } else {
                    this.taxManager = false;
                }

            });

            EventBus.$on("theme", value => {
                localStorage.setItem("theme", value);
                document.location.reload();
            });
            setTimeout(() => {
                $(".wrapper > nav").css("transition", "cubic-bezier(0.8, 0.24, 0.4, 0.9) 0.5s all");
                $(".wrapper").css("transition", "cubic-bezier(0.8, 0.24, 0.4, 0.9) 0.5s all");
            }, 100);


        },
        methods: {
            getProfile() {
                new BaseService("User", "/GetUser").getList().then(response => {
                    //this.avatar = this.validateProfilePlaceholder(this.validateProfileImage(response.data.userImage));
                    this.avatar = this.validateImageUrl(response.data.userImage);
                }).catch(error => {
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                });
            },
            passwordMatch() {
                if (this.newPassword === '' || this.repeatPassword === '') {
                    this.checkPassword = null;
                    $('.matchPassword').addClass('uncheck')
                } else if (this.newPassword !== this.repeatPassword) {
                    this.checkPassword = true;
                    $('.matchPassword').addClass('error')
                } else if (this.newPassword === this.repeatPassword) {
                    this.checkPassword = false;
                    $('.matchPassword').addClass('match')
                }
            },
            passwordValidation() {
                if (this.newPassword.length < 6) {
                    this.$noty.error("رمز عبور حداقل باید 6 حرف باشد")
                }
            },
            onChangePassword() {
                this.$refs.insertModal.showModal();
                this.newPassword = null;
                this.repeatPassword = null;
            },
            onSubmitPassword() {
                const passwordModel = {
                    mobile: localStorage.getItem('mobile'),
                    userName: localStorage.getItem('userName'),
                    passwordHash: this.newPassword
                };
                new BaseService("User", '/UpdateUserPassword').update(passwordModel).then(response => {
                    this.$refs.insertModal.hideModal();
                    this.checkPassword = null;
                    this.newPassword = null;
                    this.repeatPassword = null;
                    this.$noty.success("رمز عبور با موفقیت تغییر کرد", {timeout: 1000})
                }).catch(error => {

                });
            },
            onCollapseSidebarClicked() {
                this.sidebarCollapsed = !this.sidebarCollapsed;
                this.sidebarAnimationCompleted = false;
                setTimeout(() => {
                    this.sidebarAnimationCompleted = true;
                }, 500);
                $(".sidebar").toggleClass("collapsed");
                $(".wrapper").toggleClass("partially-wide");
                /*if (!$(".sidebar").hasClass("collapsed")) {
                    $(".sidebar .menu-container").css("margin-top", "90px");
                    setTimeout(() => {
                        $(".sidebar .menu-container").css("margin-top", "0");
                    }, 500);
                } else {
                    $(".sidebar .menu-container").css("margin-top", "90px");
                }*/
            },
            validateProfilePlaceholder(img) {
                let final = img.substr(img.lastIndexOf('/') + 1);
                let file = final.split('.');
                return "/img/" + file[0] + '.' + file[2];
            }
        }
    }
</script>

<style lang="scss" scoped>
    .nav-item .nav-link {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .nav-item .nav-link .fa-chevron-down {
        transition: all 0.3s !important;
    }

    .nav-item .nav-link.collapsed .fa-chevron-down {
        transform: rotate(90deg);
    }

    .nav-item:hover .nav-link.collapsible {
        margin-right: 0;
        cursor: pointer;
    }

    .nav-item .nav-link > span {
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }
</style>